/*
 * @Author: Jiajia Li
 * @Date: 2024-08-27 15:18:31
 * @LastEditTime: 2024-08-27 15:20:13
 * @Description:
 */

import React from "react";

import { useRouteError, Link } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="text-center">
        <h1 className="display-1 fw-bold">Opps!</h1>
        <p className="fs-3">
          <span className="text-danger">Sorry,</span> an unexpected error has
          occurred.
        </p>
        <p className="lead">
          <i>{error.statusText || error.message}</i>
        </p>
        <Link to="/home-page" className="btn btn-primary text-white">
          Go Home
        </Link>
      </div>
    </div>
  );
}
